









import {Component, Vue} from "vue-property-decorator";
import {Card} from "@/types/landing/Card";
import PartnerCard from "@/components/landing/PartnerCard.vue";

@Component({
  components: {PartnerCard},
})
export default class Partner extends Vue {
  cards: Card[] = [
    {title: "Carrefour家樂福線上購物", link: "https://online.carrefour.com.tw/", index: 1, width: 149, height: 100},
    {title: "ETMall東森購物網", link: "https://www.etmall.com.tw/", index: 2, width: 227, height: 100},
    {title: "momo購物網", link: "https://www.momoshop.com.tw/", index: 3, width: 317, height: 100},
    {title: "PChome 24h購物", link: "https://24h.pchome.com.tw/", index: 4, width: 317, height: 100},
    {title: "Rakuten樂天市場", link: "https://www.rakuten.com.tw/", index: 5, width: 317, height: 100},
  ];
}
